import React from "react";
import { useGetMachineName } from "app/view/hooks/useGetMachineName";
import { useGetParameterName } from "app/view/hooks/useGetParameterName";
import { useGetMaterialName } from "app/view/hooks/useGetMaterialById";
import SecondReport from "./SecondReport";
import { useRecoilState, useRecoilValue } from "recoil";
import { EditText } from "react-edit-text";

import {
  SingleJobTime,
  CCMetalworkingWeeksPerYear,
  WorkingHours,
} from "atoms/General/index.js";
const FirstReport = ({
  isWorkingPerJobEditable,
  staticDataOfMachine,
  ScenarioState,
  isHotSpotAvailable,
  setCppData,
  cppData,
  setTotalJobs,
  totalJobs,
  setSingleJobTime,
  singleJobTime,
  machineImage,
  setMachineimage,
  psImage,
  setPsImage,
  setcppSum,
  cppSum,
  setHotSpotArray,
  hotspotArray,

}) => {
  const workingHours = useRecoilValue(WorkingHours);

  const machineName = useGetMachineName(
    +staticDataOfMachine?.machine_id?.value
  );
  const materialName = useGetMaterialName(
    +staticDataOfMachine?.material_id?.value
  );
  const partWeight =
    staticDataOfMachine?.part_volume?.value *
    staticDataOfMachine?.material_density?.value;

  const parameterName = useGetParameterName(
    +staticDataOfMachine?.parameter_id?.value
  );

  const jobTime =
    +staticDataOfMachine?.setup_time?.value +
    +staticDataOfMachine?.build_time?.value +
    +staticDataOfMachine?.unpacking_time_per_job?.value;

  // Getting Currency Symbol...
  const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
  const currency = sessionStorage.getItem("currency");
  const obj = currencies.find((x) => x.currency_symbol === currency);

  const [workingWeeksPerYear, setWorkingWeeksPerYear] = useRecoilState(
    CCMetalworkingWeeksPerYear
  );
  const jobYear = workingWeeksPerYear * totalJobs;

  return (
    <>
    <div className="mt-36 d-flex flex-column gap-20">
      {/* First row: Part Information, Job Details, Post Processing */}
      <div className="report-row">
        {/* Part Of Information */}
        <div className="report-container  report-col">
          <div className="  d-flex justify-content-lg-between mb-36 align-items-center">
            <span className="font-24 font-semi-bold">Part Information</span>
            <span className="powder-heading">
              {staticDataOfMachine?.part_name &&
                staticDataOfMachine?.part_name?.value}
            </span>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Material </p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {materialName}
              </p>{" "}
            </span>
          </div>

          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Material price</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.material_price?.value !== undefined
                  ? `${staticDataOfMachine?.material_price?.value} ${obj.currency_symbol}/kg`
                  : "No Available"}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part volume</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.part_volume?.value !== undefined ? (
                  <>
                    {`${staticDataOfMachine?.part_volume?.value} cm`}
                    <sup>3</sup>
                  </>
                ) : (
                  "No Available"
                )}
              </p>
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part weight</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {partWeight !== undefined
                  ? `${partWeight.toFixed(2)} g`
                  : "No Available"}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part support volume</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.part_support_volume?.value ? (
                  <>
                    {`${staticDataOfMachine?.part_support_volume?.value} cm`}
                    <sup>3</sup>
                  </>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
        </div>
        {/* Job Details */}
        <div className="report-container  report-col">
          <div className="mb-36">
            <p className="font-24 font-semi-bold">Job Details</p>
          </div>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Parts per job</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.no_of_parts?.value ? (
                  <>{`${staticDataOfMachine?.no_of_parts?.value}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Total job volume</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.total_part_volume?.value ? (
                  <>
                    {`${staticDataOfMachine?.total_part_volume?.value} cm`}
                    <sup>3</sup>
                  </>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Job time</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {jobTime ? <>{`${jobTime} h`}</> : "No Available"}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Parameter</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {parameterName}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Additional material losses</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.additional_material_losses?.value ? (
                  <>{`${staticDataOfMachine?.additional_material_losses?.value} %`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
        </div>

        {/* Post Processing */}
        <div className="report-container  report-col">
          <div className=" mb-36 ">
            <p className="font-24 font-semi-bold">Post processing</p>
          </div>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Part removal cost per job</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.part_removal?.value ? (
                  <>{`${staticDataOfMachine?.part_removal?.value} ${obj.currency_symbol}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Support removal cost per job</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.support_removal?.value ? (
                  <>{`${staticDataOfMachine?.support_removal?.value} ${obj.currency_symbol}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Heat treatment per part </p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.heat_treatment?.value ? (
                  <>{`${staticDataOfMachine?.heat_treatment?.value} ${obj.currency_symbol}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Other post processing cost per part</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.other_post_processing_cost_per_part
                  ?.value ? (
                  <>{`${Math.abs(
                    staticDataOfMachine?.other_post_processing_cost_per_part
                      ?.value
                  )} ${obj.currency_symbol}`}</>
                ) : (
                  ""
                )}
              </p>{" "}
            </span>
          </div>
        </div>
      </div>

      <div className="report-row">
        {/* System Information */}
        <div className="report-container  report-col ">
          <div className=" d-flex justify-content-lg-between mb-36 align-items-center">
            <span className="font-24 font-semi-bold">System Information</span>
            <span className="powder-heading">{machineName} sdd</span>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Initial investment</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.initial_investment?.value !==
                undefined ? (
                  <>{`${staticDataOfMachine?.initial_investment?.value} ${obj.currency_symbol}`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Recurring Expense</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.recurring_expense?.value ? (
                  <>{`${staticDataOfMachine?.recurring_expense?.value} ${obj.currency_symbol}/year`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Depreciation period</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.depreciation_period?.value ? (
                  <>{`${staticDataOfMachine?.depreciation_period?.value} /year`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Interest rate</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.interest_rate?.value ? (
                  <>{`${staticDataOfMachine?.interest_rate?.value} %`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Utilization</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.utilization?.value ? (
                  <>{`${staticDataOfMachine?.utilization?.value} hours/year`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">CAPEX per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.capex_per_year?.value ? (
                  <>{`${staticDataOfMachine?.capex_per_year?.value} ${obj.currency_symbol}/year`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">System cost per hour</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.system_cost_per_hour?.value ? (
                  <>{`${staticDataOfMachine?.system_cost_per_hour?.value} ${obj.currency_symbol}/hour`}</>
                ) : (
                  "No Available"
                )}
              </p>{" "}
            </span>
          </div>
        </div>
        {/* Production Scenarios */}

        <div className="report-container report-col">
          <div className="mb-36">
            <p className="font-24 font-semi-bold">Production Scenarios</p>
          </div>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Builds per week</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {totalJobs == null ? "Not Availbel" : totalJobs}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Working weeks per year</p>
            </span>
            {isWorkingPerJobEditable === null ? (
              <span>
                <p className="font-16  color-blue font-semi-bold">
                  <EditText
                    name="working-weeks-per-year"
                    style={{ fontSize: "16px", border: "1px solid #ccc" }}
                    value={workingWeeksPerYear}
                    onChange={(event) =>
                      setWorkingWeeksPerYear(event.target.value)
                    }
                  />
                </p>
              </span>
            ) : (
              <span>
                <p className="font-16  color-blue font-semi-bold">
                  {workingWeeksPerYear == null
                    ? "Not Available"
                    : workingWeeksPerYear}
                </p>{" "}
              </span>
            )}
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Jobs per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {jobYear == null ? "Not Available" : Math.round(jobYear)}
              </p>{" "}
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Throughput per year</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {Math.trunc(
                  +(jobYear * +staticDataOfMachine?.no_of_parts?.value)
                )}
              </p>
            </span>
          </div>
          <i className="">
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Turnaround time</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">{`${singleJobTime} h`}</p>{" "}
            </span>
          </div>

          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>

          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Operators needed per machine</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {staticDataOfMachine?.number_of_operators?.value ? (
                  <>{`${staticDataOfMachine?.number_of_operators?.value}`}</>
                ) : (
                  "Not Available"
                )}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <span>
              <p className="font-16">Number of shifts</p>
            </span>
            <span>
              <p className="font-16  color-blue font-semi-bold">
                {workingHours === "true" ? 1 : 3}
              </p>{" "}
            </span>
          </div>
          <i className="">
            {" "}
            <hr className="hr-css" />
          </i>
          <div className="d-flex justify-content-between ">
            <p className="font-16">Operator’s time needed per job</p>
            <p className="font-16  color-blue font-semi-bold">
              {+staticDataOfMachine?.unpacking_time_per_job?.value +
                +staticDataOfMachine?.setup_time?.value}{" "}
              h
            </p>{" "}
          </div>
        </div>
        {/* Render Second Report inside First Report and hide First Report buttons */}
      </div>
      <SecondReport
        isWorkingPerJobEditable={isWorkingPerJobEditable}
        staticDataOfMachine={staticDataOfMachine}
        isHotSpotAvailable={isHotSpotAvailable}
        setCppData={setCppData}
        cppData={cppData}
        totalJobs={totalJobs}
        setTotalJobs={setTotalJobs}
        setSingleJobTime={setSingleJobTime}
        singleJobTime={singleJobTime}
        machineImage={machineImage}
        setMachineimage={setMachineimage}
        psImage={psImage}
        setPsImage={setPsImage}
        setcppSum={setcppSum}
        cppSum={cppSum}
        setHotSpotArray={setHotSpotArray}
        hotspotArray={hotspotArray}
        workingWeeksPerYear={workingWeeksPerYear}
        setWorkingWeeksPerYear={setWorkingWeeksPerYear}
        // PreviousScenarioState={() => setStep(STEPS.ONE)}
        // ScenarioState={() => setStep(STEPS.THREE)}
      />

     
    </div>
    
    </>
  );
};

export default FirstReport;
